const isUpperCase = (str: string) => /^[A-Z]*$/.test(str)

export function camelCaseToTrainCase(str: string) {
	return str.split("").reduce((acc, char) => {
		return isUpperCase(char) ? (acc += `-${char}`) : (acc += char.toUpperCase())
	}, "")
}
